import { Layers, Activity, GitMerge, ShieldCheck } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";

const Solution = () => {
  return (
    <section
      data-testid="solution-section"
      className="light-section pb-24 lg:pb-32 border-t border-[#e4e4e7]"
    >
      <div className="max-w-[1380px] mx-auto px-6 lg:px-10 pt-24 lg:pt-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <SectionLabel index="03" label="The compliance intelligence overlay" />
            <h2 className="mt-6 font-display font-bold text-[#090a0f] text-4xl sm:text-5xl lg:text-[58px] tracking-tight leading-[1.02]">
              No rip-and-replace.<br />
              <span className="text-[#52525b]">Just</span>{" "}
              an{" "}
              <span className="relative">
                <span className="relative z-10">intelligent layer</span>
                <span className="absolute -bottom-0 left-0 right-0 h-2 bg-[#0047ff]/15" />
              </span>
              .
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#52525b] text-[17px] leading-relaxed">
              Vendor-agnostic, configuration-driven. Sentinel sits above your existing stack — it doesn&rsquo;t replace any decision. It defends the one you make.
            </p>
          </div>
        </div>

        {/* Architecture visual */}
        <div className="mt-16 lg:mt-20 border border-[#e4e4e7] bg-white">
          {/* Sentinel overlay row */}
          <div className="bg-[#090a0f] text-white p-6 lg:p-8 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="h-10 w-10 bg-white text-[#090a0f] flex items-center justify-center">
                <Layers className="w-5 h-5" strokeWidth={2} />
              </div>
              <div>
                <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-white/50">Layer 02</p>
                <p className="font-display text-white text-[22px] font-bold tracking-tight">
                  Sentinel — Compliance Intelligence Overlay
                </p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {["Deterministic", "Explainable", "Vendor-agnostic", "Advisory only"].map((t) => (
                <span
                  key={t}
                  className="font-mono text-[10px] tracking-[0.16em] uppercase border border-white/20 px-2 py-1 text-white/80"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {/* Existing vendor row */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#e4e4e7]">
            {[
              { k: "KYC", v: "Identity & onboarding", icon: ShieldCheck, hex: "#0047ff" },
              { k: "AML", v: "Screening & monitoring", icon: GitMerge, hex: "#7c3aed" },
              { k: "TM", v: "Transaction monitoring", icon: Activity, hex: "#10b981" },
              { k: "Fraud", v: "Card & A2A fraud", icon: ShieldCheck, hex: "#f43f5e" },
            ].map((c, i) => {
              const Icon = c.icon;
              return (
                <div key={c.k} className="bg-white p-6 relative">
                  <span
                    className="absolute top-0 left-0 right-0 h-[3px]"
                    style={{ backgroundColor: c.hex }}
                  />
                  <div className="flex items-center gap-3 mb-3">
                    <Icon
                      className="w-4 h-4"
                      style={{ color: c.hex }}
                      strokeWidth={2}
                    />
                    <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#a1a1aa]">
                      Layer / 0{i + 1}
                    </p>
                  </div>
                  <p className="font-display font-bold text-[#090a0f] text-[20px] tracking-tight">
                    {c.k}
                  </p>
                  <p className="mt-1 text-[#52525b] text-[13px]">{c.v}</p>
                </div>
              );
            })}
          </div>

          {/* Data sources row */}
          <div className="bg-[#fafafa] border-t border-[#e4e4e7] p-5 flex flex-wrap items-center justify-between gap-3">
            <p className="font-mono text-[11px] tracking-[0.22em] uppercase text-[#52525b]">
              Layer 00 — Your data
            </p>
            <p className="text-[#52525b] text-[13px]">
              Standard connectors. Configuration-driven onboarding.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solution;
